import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {CssBaseline} from "@mui/material";
import {BrowserRouter} from "react-router-dom";
import {TenantThemeProvider} from "./themes/TenantThemeProvider";
import "./i18n";

// Global CSS to prevent horizontal overflow
const globalStyles = `
  * {
    box-sizing: border-box;
  }
  
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    width: 100%;
  }
  
  #root {
    width: 100%;
    overflow-x: hidden;
  }
  
  .MuiTableContainer-root {
    overflow-x: auto !important;
  }
`;

// Inject global styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Use basename only in production
const basename = process.env.NODE_ENV === "production" ? "/smartfarm" : undefined;

root.render(
  <React.StrictMode>
    <TenantThemeProvider>
      <CssBaseline />
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </TenantThemeProvider>
  </React.StrictMode>
);
